var render = function render() {
  var _vm$facet, _vm$facet2;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.SpecDate
  }, [_c('SInputDate', {
    ref: "inputDateRef",
    attrs: {
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "interval": "",
      "max-date": (_vm$facet = _vm.facet) !== null && _vm$facet !== void 0 && _vm$facet.max ? _vm.vuetifyParser(_vm.facet.max) : undefined,
      "min-date": (_vm$facet2 = _vm.facet) !== null && _vm$facet2 !== void 0 && _vm$facet2.min ? _vm.vuetifyParser(_vm.facet.min) : undefined,
      "can-watch-disabled-months": "",
      "input-size": "small",
      "error-message": _vm.errorMessage,
      "error-show": !!_vm.errorMessage
    },
    model: {
      value: _vm.dateModel,
      callback: function callback($$v) {
        _vm.dateModel = $$v;
      },
      expression: "dateModel"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };